import React from "react";
import { CompactMatchRow } from "./matchRowParts";

const pick_result_colour = (result) => {
  if (result === "W") {
    return { color: "#5da423", letterSpacing: "0.25em" };
  } else if (result === "D") {
    return { color: "#2ba6cb", letterSpacing: "0.25em" };
  } else if (result === "L") {
    return { color: "#c60f13", letterSpacing: "0.25em" };
  } else {
    return { color: "#e9e9e9", letterSpacing: "0.25em" }; // neutral
  }
};

// A coloured dot per result, hidden on small screens.
const formDots = (results) =>
  results.map((result, i) => (
    <span key={i} className="hide-for-small" style={pick_result_colour(result)}>
      ⬤
    </span>
  ));

const MatchSummary = ({ item, pool_title }) => <CompactMatchRow item={item} pool_title={pool_title} formMarks={formDots} />;

export default MatchSummary;
